var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-cross_black"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross_black",
    clipPath: "url(#clip-cross_black)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18426",
    "data-name": "Path 18426",
    d: "M4.669,4.065,8,.731a.428.428,0,0,0-.6-.6L4.064,3.46.73.126a.428.428,0,0,0-.6.6L3.459,4.065.125,7.4a.428.428,0,0,0,.6.6L4.064,4.67,7.4,8A.428.428,0,1,0,8,7.4Z",
    transform: "translate(5.938 5.936)",
    fill: "#2f394e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlack);
export default __webpack_public_path__ + "static/media/cross_black.ec6f4777ab00220111f761650475e91c.svg";
export { ForwardRef as ReactComponent };